'use client';

import { Toast } from '@base-ui/react/toast';
import type { SnackbarApi } from './types';

export function useSnackbar(): SnackbarApi {
  const manager = Toast.useToastManager();

  return {
    error: ({ title, timeout }) => {
      manager.add({
        title,
        type: 'error',
        priority: 'high',
        ...(timeout !== undefined && { timeout }),
      });
    },
    info: ({ title, timeout }) => {
      manager.add({
        title,
        type: 'info',
        priority: 'low',
        ...(timeout !== undefined && { timeout }),
      });
    },
    success: ({ title, timeout }) => {
      manager.add({
        title,
        type: 'success',
        priority: 'low',
        ...(timeout !== undefined && { timeout }),
      });
    },
    dismiss: id => manager.close(id),
  };
}
